import axios from 'axios';
import config from '../../../../config/index';
import { token } from '../../../login/duck/actions/login';

const removeOrganisation = (shortCode, bundleId, userEmail) => {
  return axios.delete(
    `${config.host}/bundles/${bundleId}/organization/remove`,
    {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      data: {
        shortCode,
        userEmail,
      },
    },
  );
};

export { removeOrganisation };
